import { getOrderStorageDays } from "../../core/constants/orderStorage"
import { getOrders } from "../../service/OrderService"
import { useQuery } from "react-query"

export default function useResumeOrder(tunnelData, payload) {
  const { shopId, orderOrName, statusOPLs, sort, rowsDisplayed, offset } = payload
  const statusOPLsToStringArray = statusOPLs && statusOPLs.length !== 0 ? statusOPLs.map(String) : null
  const orderStorageDays = getOrderStorageDays(tunnelData?.tenant)

  const { data: orders, isLoading: isLoadingOrders } = useQuery({
    queryKey: ["query-orders", shopId, orderOrName, statusOPLsToStringArray, sort, rowsDisplayed, offset, orderStorageDays],
    queryFn: () =>
      getOrders(tunnelData, {
        shopId,
        clientNameOrOPL: orderOrName,
        statusOPLs: statusOPLsToStringArray,
        sort,
        orderStorageTime: orderStorageDays,
        rowsDisplayed,
        offset
      }),
    enabled: !!shopId,
    refetchOnWindowFocus: false
  })

  return {
    orders,
    isLoadingOrders
  }
}
